import { Helmet } from 'react-helmet-async';

interface WebPageProps {
  type: 'WebPage';
  name: string;
  description?: string;
  url: string;
}

interface ArticleProps {
  type: 'Article';
  headline: string;
  description?: string;
  image?: string;
  datePublished?: string;
  url: string;
}

interface WebSiteProps {
  type: 'WebSite';
  name: string;
  url: string;
  searchUrl?: string;
}

type StructuredDataProps = WebPageProps | ArticleProps | WebSiteProps;

function buildSchema(props: StructuredDataProps): Record<string, unknown> {
  const base = { '@context': 'https://schema.org' };

  switch (props.type) {
    case 'WebPage':
      return {
        ...base,
        '@type': 'WebPage',
        name: props.name,
        description: props.description,
        url: props.url,
      };

    case 'Article':
      return {
        ...base,
        '@type': 'Article',
        headline: props.headline,
        description: props.description,
        image: props.image,
        datePublished: props.datePublished,
        url: props.url,
      };

    case 'WebSite': {
      const schema: Record<string, unknown> = {
        ...base,
        '@type': 'WebSite',
        name: props.name,
        url: props.url,
      };
      if (props.searchUrl) {
        schema['potentialAction'] = {
          '@type': 'SearchAction',
          target: { '@type': 'EntryPoint', urlTemplate: props.searchUrl },
          'query-input': 'required name=search_term_string',
        };
      }
      return schema;
    }
  }
}

export function StructuredData(props: StructuredDataProps) {
  const schema = buildSchema(props);
  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(schema)}</script>
    </Helmet>
  );
}
